// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__220ZR","colMin":"styles_colMin__27G18","colCheckbox":"styles_colCheckbox__1NxVY"};